import { ServiceResult } from './service-result';

export class TServiceResult<T> extends ServiceResult {
    constructor(
        retVal: T,
        message: string,
        errors: any,
        hasError: boolean,
        refrenceId: string,
    ) {
        super(message, errors, hasError, refrenceId)
        this.result = retVal;
    }

    public static from<T>(retVal: T, msg: string): TServiceResult<T> {
        return new TServiceResult(retVal, msg, null, false, '')
    }

    public static fromFailure<T>(err: any): TServiceResult<T> {
        return new TServiceResult<T>({} as T, '', err, true, '')
    }

    result: T;
}